module.exports = __webpack_public_path__ + "static/media/GongXiang5.cb187cf0.png";